import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as AEMActions from '../+state/actions/content.actions';

@Injectable({
  providedIn: 'root'
})
export class StateFacade {
  constructor(private readonly store: Store) {}

  init() {
    this.store.dispatch(AEMActions.loadAEMContent());
    this.store.dispatch(AEMActions.loadAEMSummaryContent());
    this.store.dispatch(AEMActions.loadAEMErrorMessages());
    this.store.dispatch(AEMActions.loadAEMFeatureFlags());
  }
}
